import Vue from "vue";
import Ionic from "@ionic/vue";

import App from "./App.vue";
import router from "./router";

import { firebase } from '@firebase/app'

import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/main.css'

import { defineCustomElements } from '@ionic/pwa-elements/loader';

Vue.config.productionTip = false;
Vue.prototype.bus = new Vue()
import store from './store'

import VueSimpleAlert from "vue-simple-alert"
Vue.use(VueSimpleAlert)

// const firebaseConfig = {
//   apiKey: "AIzaSyD9VFxOB4931Gn8vYahDqg1wHABDLRlmjo",
//   authDomain: "tk3-checkin-client.firebaseapp.com",
//   projectId: "tk3-checkin-client",
//   storageBucket: "tk3-checkin-client.appspot.com",
//   messagingSenderId: "536422938319",
//   appId: "1:536422938319:web:3c57913fb3a4ba0498e9ba"
// }

const firebaseConfig = {
  apiKey: "AIzaSyCI09AvfFfMuNkhvLIJujspEvjaCe2ten0",
  authDomain: "timekeeper-264503.firebaseapp.com",
  projectId: "timekeeper-264503",
  messagingSenderId: "183021784010",
  appId: "1:183021784010:web:1a1fe110a37a3b29479d33",
}


firebase.initializeApp(firebaseConfig);

import "firebase/auth"
import './registerServiceWorker'

Vue.mixin({
  methods: {
    getUser() {
      return(firebase.auth().currentUser)
    },

    getUserOrg() {
      return(this.$store.state.orgId)
    },

    saveUserProfile(orgId){
      this.$store.commit('set', ['orgId', orgId])
    },

    getPendingCheckins() {
      return(this.$store.state.pendingCheckins)
    },

    setPendingCheckins(pendingCheckins) {
      this.$store.commit('set', ['pendingCheckins', pendingCheckins])
    },

  },
})


Vue.use(Ionic);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

defineCustomElements(window);
